import {HTTP} from "../../helpers/axios";
// src/thunks.ts
import {AxiosResponse} from "axios";
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";
import {UsersSettingsDataInterface} from "../../dataInterface/userSettingsDataInterface";


export const getUserSettingsByTypeByUser = (data:object,callback:(error:boolean,data:UsersSettingsDataInterface)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    try {
        const response =  await   HTTP(getState,dispatch).post(serverRoutes.getUserSettingsByTypeByUser,data);


        dispatch({
            type: 'GET_TYPE_USER_SETTINGS',
            payload: response.data
        });

        let error=false;
        callback(error,response.data as UsersSettingsDataInterface);
    }catch (e) {
        console.log(e);
        let error=true;
        callback(error,{} as UsersSettingsDataInterface);
    }


};

